import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import type { EntityWatcherModel } from '../interfaces';
import { BaseEntity } from './base.entity';
import { IssueEntity } from './issue.entity';
import { UserEntity } from './user.entity';

/**
 * Entity for tracking users who are watching an issue.
 * Used by the notification system to send activity updates.
 */
@Index('issue_user__fk_user__id_fk', ['fkUserId'], {})
@Index('issue_user_pk', ['fkIssueId', 'fkUserId'], { unique: true })
@Entity('issue_user')
export class IssueUserEntity extends BaseEntity implements EntityWatcherModel {
	@Column('int', { name: '_fk_issue__id', unsigned: true })
	public fkIssueId!: number;

	@Column('int', { name: '_fk_user__id', unsigned: true })
	public fkUserId!: number;

	@ManyToOne(() => UserEntity, (user) => user.issueUsers, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;

	@ManyToOne(() => IssueEntity, (issue) => issue.issueUsers, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_issue__id', referencedColumnName: 'id' }])
	public fkIssue!: IssueEntity;
}
